import axios from "axios";
import { ENDPOINT } from "../config";
import { setData, setSessionData } from "../redux/actions";

const ACCOUNT_STATUS_CODES = new Set(["ACCOUNT_INACTIVE", "ACCOUNT_PENDING"]);

const redirectToSignIn = (message) => {
  setData({});
  setSessionData({});
  localStorage.clear();
  if (message) {
    sessionStorage.setItem("login_message", message);
  }
  window.location.assign("/sign-in");
};

export const MakeApiCall = async (
  url,
  method = "get",
  data = null,
  withBearer = false,
  headers_ = {},
  token,
  options = {}
) => {
  const { skipAuthRedirect = false, signal = undefined } = options;
  try {
    // const headers = {
    //   "Content-Type": "application/json",

    //   ...headers_,
    // };

    const headers = {
      // Only include default headers if data is not FormData
      ...(data instanceof FormData
        ? {}
        : { "Content-Type": "application/json" }),
      ...headers_,
    };

    if (typeof window !== 'undefined') {
      const lang = localStorage.getItem('i18nextLang');
      if (lang) {
        headers['Accept-Language'] = lang;
      }
    }

    if (withBearer) {
      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      } else {
        localStorage.clear();
        return window.location.assign("/sign-in");
      }
    }
    let url_ = ENDPOINT + url;
    const response = await axios({
      method,
      url: url_,
      data: data || null,
      headers,
      redirect: "follow",
      signal,
    });

    return response.data;
  } catch (error) {
    const errorData = error?.response?.data;

    if (!skipAuthRedirect && error?.response?.status === 401) {
      redirectToSignIn();
      return;
    }

    if (
      !skipAuthRedirect &&
      error?.response?.status === 403 &&
      ACCOUNT_STATUS_CODES.has(errorData?.code)
    ) {
      redirectToSignIn(
        errorData?.message || "Your account is inactive. Contact your administrator."
      );
      return;
    }

    if (errorData) {
      return errorData;
    }
    return { message: error?.message, status: false };
  }
};
